"use client";

import { Card } from "react-bootstrap";

const Attachments = () => {
  // Dynamic data for attachments
  const attachments = [
    { name: "Project_attachment_1.zip", size: "3.25 MB" },
    { name: "Project_attachment_2.zip", size: "4.15 MB" },
    { name: "Project_attachment_3.zip", size: "2.75 MB" },
    { name: "Project_attachment_4.zip", size: "5.05 MB" },
  ];

  return (
    <>
      <Card className="bg-white border-0 rounded-3 mb-4 rounded-3">
        <Card.Body className="p-4">
          <h3 className="mb-4">Attachments</h3>

          {attachments.map((attachment, index) => (
            <div
              key={index}
              className="d-flex justify-content-between align-items-center bg-body-bg p-3 rounded-3 mb-3 lcmb-none"
            >
              <div className="d-flex align-items-center">
                <div className="flex-shrink-0">
                  <i className="ri-file-warning-line wh-40 lh-40 d-inline-block bg-white text-center fs-18 text-primary rounded-circle"></i>
                </div>
                <div className="flex-grow-1 ms-3">
                  <h4 className="mb-1 fs-14 fw-medium">{attachment.name}</h4>
                  <span className="fs-13">{attachment.size}</span>
                </div>
              </div>

              <button className="p-0 border-0 bg-transparent">
                <i className="ri-download-2-line fs-22 text-primary"></i>
              </button>
            </div>
          ))}
        </Card.Body>
      </Card>
    </>
  );
};

export default Attachments;
